import { tv } from 'tailwind-variants'

export const dialogVariants = tv({
  base: ['relative z-10', 'p-6', 'text-white', 'rounded-xl bg-charcoal overflow-hidden'],
  variants: {
    accentColor: {
      none: '',
      yellow: 'shadow-yellow-top-accent',
      green: 'shadow-green-top-accent',
      blue: 'shadow-blue-top-accent',
      pink: 'shadow-pink-top-accent'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})
